import React from 'react';
import EntryGuidePrintButton from '../EntryGuides/EntryGuidePrintButton';

const SalesQuotePrintButton = ({ quoteId, className }) => (
  <EntryGuidePrintButton
    className={className}
    title="Imprimir"
    onClick={() => window.open(`/ventas/quotes/${quoteId}/print`, '_blank', 'noopener,noreferrer')}
  />
);

export default SalesQuotePrintButton;
